import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import ServicesContext from './ServicesContext';
import ServicesReducer from './ServicesReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const ServicesState = (props) => {
    const initialState = {
        getServices: {
            services: [],
            firstService: null,
            lastService: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createServices: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateServicesById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCategoriesServices: {
            categoriesServices: [],
            firstCategoryService: null,
            lastCategoryService: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCategoriesServicesById: {
            categoryService: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCategoriesServices: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCategoriesServicesById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getSubCategoriesServicesById: {
            subCategoriesServices: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createSubCategoriesServices: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    };

    const [state, dispatch] = useReducer(ServicesReducer, initialState);

    const { authenticatedState } = useContext(AuthenticationContext);

    const getServices = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_SERVICES_LOADING' });

        getGlobalServices(nextPage, prevPage, notPagination);
    };

    const getGlobalServices = (nextPage, prevPage, notPagination) => {
        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collectionGroup("Servicios")

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        } else if (nextPage) {
            db.collectionGroup('Servicios')
            .where('servicioId', '==', nextPage)
            .get()
            .then((querySnapshot) => {
                const dataAfter = querySnapshot.docs[0];

                let first = db.collectionGroup("Servicios")
                .startAfter(dataAfter)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else if (prevPage) {
            db.collectionGroup('Servicios')
            .where('servicioId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collectionGroup("Servicios")
                .endBefore(dataBefore)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else {
            let first = db.collectionGroup("Servicios")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        }
    }

    const createServices = (data) => {
        dispatch({ type: 'CREATE_SERVICES_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection('CategoriasServicios').doc(data.categorySelect)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.ref.collection("Servicios").add({
                            categoriaServicioId: data.categorySelect,
                            nombre: data.name,
                            status: data.status,
                            imagen: downloadURL
                        }).then((doc) => {
                            querySnapshot.ref.collection("Servicios").doc(doc.id).update({
                                servicioId: doc.id
                            }).then(() => {
                                dispatch({ type: 'CREATE_SERVICES', payload: { data: data } })
                            })
                        })
                    })
                    .catch((error) => dispatch({ type: 'CREATE_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
                });
            });
        } else {
            db.collection('CategoriasServicios').doc(data.categorySelect)
            .get()
            .then((querySnapshot) => {
                querySnapshot.ref.collection("Servicios").add({
                    categoriaServicioId: data.categorySelect,
                    nombre: data.name,
                    status: data.status,
                    imagen: ""
                }).then((doc) => {
                    querySnapshot.ref.collection("Servicios").doc(doc.id).update({
                        servicioId: doc.id
                    }).then(() => {
                        dispatch({ type: 'CREATE_SERVICES', payload: { data: data } })
                    })
                })
            })
            .catch((error) => dispatch({ type: 'CREATE_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        }
    };

    const updateServicesById = (serviceId, data) => {
        dispatch({ type: 'UPDATE_SERVICES_BY_ID_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection('CategoriasServicios').doc(data.category).doc(serviceId).update({
                        nombre: data.name,
                        status: data.status,
                        palabrasClave: data.keyPhrases,
                        imagen: downloadURL
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_SERVICES_BY_ID', payload: { data: data } })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_SERVICES_BY_ID_ERROR', payload: { code: 'services/error', message: error } }))
                });
            });
        } else {
            if (data.deleteImage && data.imagePath.length > 0) {
                let storageRef = storage.refFromURL(data.imagePath);

                storageRef.delete().then(function() {
                    db.collection('CategoriasServicios').doc(data.category).collection("Servicios").doc(serviceId).update({
                        nombre: data.name,
                        status: data.status,
                        palabrasClave: data.keyPhrases,
                        imagen: ""
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_SERVICES_BY_ID', payload: { data: data } })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_SERVICES_BY_ID_ERROR', payload: { code: 'services/error', message: error } }))
                }).catch(function(error) {
                    dispatch({ type: 'UPDATE_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                });
            } else {
                db.collection('CategoriasServicios').doc(data.category).collection("Servicios").doc(serviceId).update({
                    nombre: data.name,
                    status: data.status,
                    palabrasClave: data.keyPhrases
                }).then((doc) => {
                    dispatch({ type: 'UPDATE_SERVICES_BY_ID', payload: { data: data } })
                })
                .catch((error) => dispatch({ type: 'UPDATE_SERVICES_BY_ID_ERROR', payload: { code: 'services/error', message: error } }))
            }
        }
    }

    const getCategoriesServices = (nextPage, prevPage, notPagination, isOld) => {
        dispatch({ type: 'GET_CATEGORIES_SERVICES_LOADING' });

        if (isOld) {
            getGlobalCategoriesServicesOld(nextPage, prevPage, notPagination);
        } else {
            getGlobalCategoriesServices(nextPage, prevPage, notPagination);
        }
    };

    const getGlobalCategoriesServices = (nextPage, prevPage, notPagination) => {
        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("CategoriasServicios")

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.id), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        } else if (nextPage) {
            db.collection('CategoriasServicios')
            .where('categoriaServicioId', '==', nextPage)
            .get()
            .then((querySnapshot) => {
                const dataAfter = querySnapshot.docs[0];

                let first = db.collection("CategoriasServicios")
                .where("categoriaPadreId", "==", "")
                .startAfter(dataAfter)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else if (prevPage) {
            db.collection('CategoriasServicios')
            .where('categoriaServicioId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("CategoriasServicios")
                .where("categoriaPadreId", "==", "")
                .endBefore(dataBefore)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else {
            let first = db.collection("CategoriasServicios")
                .where("categoriaPadreId", "==", "")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        }
    };

    const getGlobalCategoriesServicesOld = (nextPage, prevPage, notPagination) => {
        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("CategoriasServicio")

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        } else if (nextPage) {
            db.collection('CategoriasServicio')
            .where('categoriaServicioId', '==', nextPage)
            .get()
            .then((querySnapshot) => {
                const dataAfter = querySnapshot.docs[0];

                let first = db.collection("CategoriasServicio")
                .where("categoriaPadreId", "==", "")
                .startAfter(dataAfter)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else if (prevPage) {
            db.collection('CategoriasServicio')
            .where('categoriaServicioId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("CategoriasServicio")
                .where("categoriaPadreId", "==", "")
                .endBefore(dataBefore)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))
        } else {
            let first = db.collection("CategoriasServicio")
                .where("categoriaPadreId", "==", "")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CATEGORIES_SERVICES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } }))   
        }
    };

    const getCategoriesServicesById = (id) => {
        dispatch({ type: 'GET_CATEGORIES_SERVICES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('CategoriasServicios')
            .where('categoriaServicioId', '==', id)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_CATEGORIES_SERVICES_BY_ID', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
            })
            .catch((error) => dispatch({ type: 'GET_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'services/error', message: error } }))
    };

    const createCategoriesServices = (data) => {
        dispatch({ type: 'CREATE_CATEGORIES_SERVICES_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("CategoriasServicio").add({
                        categoriaPadreId: "",
                        categoriaServicioId: "",
                        categoriaRaizId: "",
                        imagen: downloadURL,
                        nivel: 1,
                        nombre: data.name,
                        status: data.status
                    })
                    .then((docRef) => {
                        let docCategory = db.collection("CategoriasServicio").doc(docRef.id);
            
                        docCategory.update({
                            categoriaServicioId: docRef.id
                        })
                        .then(() => {
                            dispatch({ type: 'CREATE_CATEGORIES_SERVICES' })
                        })
                        .catch((error) => {
                            dispatch({ type: 'CREATE_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                        });
                    }).catch((error) => {
                        dispatch({ type: 'CREATE_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                    });
                });
            });
        } else {
            db.collection("CategoriasServicio").add({
                categoriaPadreId: "",
                categoriaServicioId: "",
                categoriaRaizId: "",
                imagen: "",
                nivel: 1,
                nombre: data.name,
                status: data.status
            })
            .then((docRef) => {
                let docCategory = db.collection("CategoriasServicio").doc(docRef.id);
    
                docCategory.update({
                    categoriaServicioId: docRef.id
                })
                .then(() => {
                    dispatch({ type: 'CREATE_CATEGORIES_SERVICES' })
                })
                .catch((error) => {
                    dispatch({ type: 'CREATE_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                });
            }).catch((error) => {
                dispatch({ type: 'CREATE_CATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
            });
        }
    };

    const createCategoriesWithExcel = async (data) => {
        dispatch({ type: 'CREATE_CATEGORIES_SERVICES_LOADING' });

        let db = firebase.firestore();

        await data.forEach((doc) => {
            let parentId = '';

            db.collection("CategoriasServicios").add({
                categoriaPadreId: "",
                categoriaServicioId: "",
                categoriaRaizId: "",
                imagen: "",
                nivel: 1,
                nombre: doc.category,
                status: 'Active'
            }).then((docRef) => {
                parentId = docRef.id;

                db.collection("CategoriasServicios").doc(docRef.id).update({
                    categoriaServicioId: docRef.id,
                }).then(() => {
                    doc.subCategories.forEach((subCategory) => {
                        db.collection("CategoriasServicios").add({
                            categoriaPadreId: parentId,
                            categoriaServicioId: "",
                            categoriaRaizId: parentId,
                            imagen: "",
                            nivel: 1,
                            nombre: subCategory,
                            status: 'Active'
                        }).then((docRef) => {
                            db.collection("CategoriasServicios").doc(docRef.id).update({
                                categoriaServicioId: docRef.id,
                            });
                        }); 
                    });
                });
            });
        });

        dispatch({ type: 'CREATE_CATEGORIES_SERVICES' });
    };

    const createCategoriesServicesResetState = () => {
        dispatch({ type: 'CREATE_CATEGORIES_SERVICES_RESET_STATE' });
    }

    const updateCategoriesServicesById = (id, data) => {
        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        let docRef = db.collection("CategoriasServicio").doc(id);

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    docRef.update({
                        nombre: data.name,
                        status: data.status,
                        imagen: downloadURL
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                    });
                });
            });
        } else {
            if (data.deleteImage && data.imagePath.length > 0) {
                let storageRef = storage.refFromURL(data.imagePath);

                storageRef.delete().then(function() {
                    docRef.update({
                        nombre: data.name,
                        status: data.status,
                        imagen: ""
                    })
                    .then(() => {
                        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID' });
                    })
                    .catch((error) => {
                        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                    });
                }).catch(function(error) {
                    console.log(error)
                    dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                });
            } else {
                docRef.update({
                    nombre: data.name,
                    status: data.status
                })
                .then(() => {
                    dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID' });
                })
                .catch((error) => {
                    dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'service/update-error', message: error } });
                });
            }
        }
    };

    const getSubCategoriesServicesById = (id) => {
        dispatch({ type: 'GET_SUBCATEGORIES_SERVICES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collectionGroup('CategoriasServicio')
            .where('categoriaPadreId', '==', id)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_SUBCATEGORIES_SERVICES_BY_ID', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
            })
            .catch((error) => dispatch({ type: 'GET_SUBCATEGORIES_SERVICES_BY_ID_ERROR', payload: { code: 'services/error', message: error } }))
    };

    const createSubCategoriesServices = (data) => {
        dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.image) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`IconosCategorias/${data.image.name}`).put(data.image, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection("CategoriasServicio").add({
                        categoriaPadreId: data.categorySelect,
                        categoriaServicioId: "",
                        categoriaRaizId: data.categorySelect,
                        imagen: downloadURL,
                        nivel: 2,
                        nombre: data.name,
                        status: data.status
                    })
                    .then((docRef) => {
                        let docCategory = db.collection("CategoriasServicios").doc(docRef.id);
            
                        docCategory.update({
                            categoriaServicioId: docRef.id
                        })
                        .then(() => {
                            dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES' })
                        })
                        .catch((error) => {
                            dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                        });
                    }).catch((error) => {
                        dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                    });
                });
            });
        } else {
            db.collection("CategoriasServicio").add({
                categoriaPadreId: data.categorySelect,
                categoriaServicioId: "",
                categoriaRaizId: data.categorySelect,
                imagen: "",
                nivel: 2,
                nombre: data.name,
                status: data.status
            })
            .then((docRef) => {
                let docCategory = db.collection("CategoriasServicio").doc(docRef.id);
    
                docCategory.update({
                    categoriaServicioId: docRef.id
                })
                .then(() => {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES' })
                })
                .catch((error) => {
                    dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
                });
            }).catch((error) => {
                dispatch({ type: 'CREATE_SUBCATEGORIES_SERVICES_ERROR', payload: { code: 'services/error', message: error } })
            });
        }
    };

    const updateResetCategoriesServices = () => {
        dispatch({ type: 'UPDATE_CATEGORIES_SERVICES_RESET_STATE' });
    };

    return (
        <ServicesContext.Provider value={{
            servicesState: state.getServices,
            createServicesState: state.createServices,
            updateServicesByIdState: state.updateServicesById,
            categoriesServicesState: state.getCategoriesServices,
            categoryServiceByIdState: state.getCategoriesServicesById,
            createCategoriesServicesState: state.createCategoriesServices,
            updateCategoriesServicesByIdState: state.updateCategoriesServicesById,
            subCategoriesServicesByIdState: state.getSubCategoriesServicesById,
            createSubCategoriesServicesState: state.createSubCategoriesServices,
            getServices,
            createServices,
            updateServicesById,
            getCategoriesServices,
            getCategoriesServicesById,
            createCategoriesWithExcel,
            createCategoriesServices,
            createCategoriesServicesResetState,
            updateCategoriesServicesById,
            getSubCategoriesServicesById,
            createSubCategoriesServices,
            updateResetCategoriesServices
        }}>
            {props.children}
        </ServicesContext.Provider>
    )
}

export default ServicesState;
